import { Button, Popover } from "@pankod/refine-antd";
import React, { useState } from "react";

export interface Props {
  title: string;
  text: string;
  onclickYes?: any;
}

export const ButtonPopover: React.FC<Props> = ({ title, text, onclickYes }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleNo = () => {
    setIsPopoverOpen(true);
    setTimeout(() => {
      setIsPopoverOpen(false);
    }, 100);
  };

  const handleYes = async () => {
    const res = await onclickYes();
    if (res) {
      handleNo();
    }
  };

  const content = () => {
    return (
      <div style={{ display: "flex" }}>
        <Button style={{ margin: "0px 10px 0px auto" }} onClick={handleNo}>
          No
        </Button>
        <Button onClick={handleYes}>Yes</Button>
      </div>
    );
  };

  return (
    <div>
      {!isPopoverOpen ? (
        <Popover
          placement="top"
          title={<div style={{ minWidth: "280px" }}>{title}</div>}
          content={content}
          trigger="click"
        >
          <Button>{text}</Button>
        </Popover>
      ) : (
        <Button>{text}</Button>
      )}
    </div>
  );
};
